<template>
  <div>
    <v-select
      v-model="paymentTypeID"
      :items="paymentTypes"
      item-text="text"
      item-value="value"
      label="Choose a Payment Type"
      prepend-icon="fa-credit-card"
      @change="setDefaultAmount()"
    />
    <v-form>
      <v-currency-field
        v-if="paymentTypeID"
        v-model="paymentAmount"
        :max="maxAmount"
        label="Amount"
      />
      <!-- forms -->
      <Credit
        v-if="paymentTypeID=='creditCard'"
        @update="formUpdated"
        @validate="validate"
      />
      <!-- check or money order -->
      <check
        v-if="paymentTypeID == 'check' || paymentTypeID == 'moneyOrder'"
        @update="formUpdated"
        @validate="validate"
      />
      <v-btn
        color="red"
        dark
        @click="$router.go(-1)"
      >
        Back
      </v-btn>
      <v-btn
        v-if="paymentTypeID"
        :disabled="paymentTypeID != 'cash' && paymentTypeID != 'baxterBucks' && !valid"
        :loading="isProcessing"
        @click="submit">
        Submit Payment
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import Credit from './Credit'
import Check from './Check'
import { mapGetters } from 'vuex'
export default {
  components: {
    Credit,
    Check
  },
  props: {
    balance: {
      type: Number,
      default: 0
    },
    isProcessing: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      valid: false,
      paymentAmount: null,
      paymentTypes: [
        {
          text: 'Cash',
          value: 'cash'
        },
        {
          text: 'Credit Card',
          value: 'creditCard'
        },
        {
          text: 'Check',
          value: 'check'
        },
        {
          text: 'Money Order',
          value: 'moneyOrder'
        },
        {
          text: 'Baxter Bucks',
          value: 'baxterBucks'
        }
      ],
      paymentTypeID: null,
      currentFormData: null
    }
  },
  computed: {
    ...mapGetters({
      baxterBucks: 'person/baxterBucks'
    }),
    maxAmount () {
      return String((this.paymentTypeID === 'baxterBucks' && this.baxterBucks < this.balance ? Number(this.baxterBucks) : this.balance).toFixed(2))
    }
  },
  methods: {
    setDefaultAmount () {
      this.paymentAmount = String(this.balance.toFixed(2))
    },
    formUpdated (formData) {
      this.currentFormData = formData
    },
    validate (valid) {
      this.valid = valid
    },
    submit () {
      let paymentData = {
        paymentTypeID: this.paymentTypeID,
        amount: this.paymentAmount,
        ...this.currentFormData
      }
      this.$emit('submit', paymentData)
    }
  }
}
</script>
